import React from 'react'
import { useTranslation } from 'react-i18next'

import { BreakScreenButton } from 'components/BreakScreenLayout'

import { useNextStep } from 'hooks/useNextStep'

import { TPageProps } from 'models/common.model'

import { StyledStableIntro as S } from './StableIntro.styles'

export const StableIntro: React.FC<TPageProps> = ({ pageId, nextPagePath }) => {
  const { t } = useTranslation()

  const handleContinue = useNextStep({
    pageId,
    question: pageId,
    nextPagePath,
  })

  return (
    <S.Wrapper>
      <BreakScreenButton type="button" onClick={() => handleContinue('')}>
        {t('actions.continue')}
      </BreakScreenButton>
    </S.Wrapper>
  )
}
